import _extends from "@babel/runtime/helpers/extends";

/*
 * @Author: wangshengqiang
 * @Date: 2021-05-18 11:28:39
 * @LastEditTime: 2022-02-23 16:49:48
 * @LastEditors: wangshengqiang
 * @Description: 弹窗组件
 */
import React, { useEffect, useState } from 'react';
import classnames from 'classnames';
import { Icon } from 'zarm';
import Render from '@/components/Render';
import { findModuleFromPage } from '@/utils/utils';
import { dispatch } from '@/store';
import EventBtn from '@/components/EventBtn/index.js'; // import { getLocalClick } from '../Button';

import { useCurrentModule } from '../BaseModule';
import './index.less';

const renderBy = status => node => {
  return status ? node : null;
};

const toolbarStyleHTML = {
  __html: `
    .components-toolbar-render {
      z-index: 11 !important;
    }
  `
};
const moduleStyleHTML = {
  __html: `
    .components-modal-render.module-bottom {
      bottom: 61px !important;
      position: fixed;
    }
  `
}; // type,  弹窗类型 弹窗1 - 通栏底色单按钮  弹窗2 - 单按钮高亮文字 弹窗3 - 无按钮 弹窗4 - 双按钮
// position, 弹窗出现位置 中部弹窗 | 底部弹窗
// title,
// button = [],
// dataSource = []
// visible

const Modal = /*#__PURE__*/React.forwardRef((props = {}, ref) => {
  const {
    attrs = {},
    form
  } = props;
  const {
    type,
    position,
    title,
    button = [],
    dataSource = [],
    visible
  } = attrs;
  const [isShow, setIsShow] = useState(visible);
  const moduleConfig = useCurrentModule();
  const hadToolbar = findModuleFromPage((curr = {}) => {
    return curr && curr.component === 'healthToolbarModule';
  });
  const showButton = !(type === 3 || position === 'bottom');
  const showTitle = (type === 1 || type === 2 || type === 4) && position !== 'bottom';
  const className = position ? `module-${position}` : '';
  const primary = type === 1;

  const _button = type === 1 || type === 2 ? button.slice(1) : button;

  const headerNode = renderBy(showTitle && title)( /*#__PURE__*/React.createElement("div", {
    className: "module-header"
  }, " ", title, " "));
  const bodyNode = /*#__PURE__*/React.createElement("div", {
    className: "module-body"
  }, /*#__PURE__*/React.createElement(Render, {
    components: dataSource
  }), ' ');
  const closeNode = /*#__PURE__*/React.createElement("div", {
    className: "module-close",
    onClick: () => {
      setIsShow(false);
    }
  }, /*#__PURE__*/React.createElement(Icon, {
    className: "icon",
    type: "wrong"
  }));
  const toolbarStyleNode = renderBy(position === 'bottom')( /*#__PURE__*/React.createElement("style", {
    dangerouslySetInnerHTML: toolbarStyleHTML
  }));
  const moduleStyleNode = renderBy(hadToolbar)( /*#__PURE__*/React.createElement("style", {
    dangerouslySetInnerHTML: moduleStyleHTML
  }));
  const children = /*#__PURE__*/React.createElement(React.Fragment, null, ' ', toolbarStyleNode, " ", moduleStyleNode, ' ', /*#__PURE__*/React.createElement("div", {
    className: "modal-module"
  }, ' ', headerNode, " ", bodyNode, " ", closeNode, ' '), ' ');

  const operations = _button.map((item = {}, index) => {
    const {
      text,
      events = {}
    } = item; // const onClick = getLocalClick(events, (opt, next) => {
    //   const { type = '', behavior = '' } = opt;
    //   if (type === 'behavior' && behavior === 'continue') {
    //     return () => {
    //       getNextStep(moduleConfig.id);
    //     };
    //   }
    //   return next;
    // });

    let itemType;
    let shadow = false;

    if (primary) {
      itemType = 'primary';
    } else {
      itemType = index === 1 ? 'primary' : '';
      shadow = index === 1;
    }

    const itemCls = classnames({
      'operations-item': true,
      'item-shadow': !!shadow,
      [`item-${itemType}`]: !!itemType
    });
    const btnProps = {
      form,
      className: itemCls,
      buttonText: text,
      events
    };
    return /*#__PURE__*/React.createElement(EventBtn, _extends({
      key: index
    }, btnProps));
  });

  const cls = classnames({
    'components-modal-render': true,
    [className]: !!className
  });
  useEffect(() => {
    setIsShow(visible);
  }, [visible]); // 组件渲染后把组件对外暴漏的方法写入store

  useEffect(() => {
    dispatch(`component_${moduleConfig.id}`, {
      show() {
        setIsShow(true);
      },

      hide() {
        setIsShow(false);
      }

    });
  }, []);
  if (!isShow) return null;
  return /*#__PURE__*/React.createElement("div", {
    className: "modal-container"
  }, /*#__PURE__*/React.createElement("div", {
    ref: ref,
    className: cls
  }, /*#__PURE__*/React.createElement("div", {
    className: "modal-content"
  }, " ", children, " "), ' ', showButton && /*#__PURE__*/React.createElement("div", {
    className: "modal-operations"
  }, " ", operations, " "), ' '));
});
export default Modal;